import React from 'react';
import { motion } from 'framer-motion';
export function AttentionHero() {
  return <section className="relative w-full overflow-hidden bg-forest-deep" data-id="element-14" data-mp="74v9d233vcne">
      <div className="leaf-watermark pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" data-id="element-15" data-mp="72s81lwi5x3d" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-5 py-12 sm:px-6 lg:grid-cols-[55%_45%] lg:gap-10 lg:py-16" data-id="element-16" data-mp="lvc5q70vvcdf">
        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="order-2 text-center text-[32px] font-bold uppercase leading-[1.03] tracking-tight text-white sm:text-[44px] lg:order-1 lg:text-left lg:text-[56px]" data-id="element-17" data-mp="usmixxx9hbkz">
          Elimina los{' '}
          <span className="text-gold" data-id="element-18" data-mp="36iyphllkueuj">parásitos y bacterias</span>{' '}
          de tu cuerpo{' '}
          <motion.span animate={{
          opacity: [1, 0.35, 1]
        }} transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'linear'
        }} className="inline-block text-coral" data-id="element-19" data-mp="31lf5e52777uo">
            sin fármacos dañinos
          </motion.span>
        </motion.h2>

        {/* Floating cover */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.08
      }} className="order-1 flex justify-center lg:order-2" data-id="element-20" data-mp="34s8rlrakqknp">
          <motion.img src="https://cdn.magicpatterns.com/uploads/bqLPxhhTW2XYbUNzG1w8kL/Portada_Principal.jpg" alt="Portada del ebook El Método de Vaciado Biológico" className="w-full max-w-[360px] rounded-2xl shadow-[0_28px_70px_rgba(0,0,0,0.45)] ring-1 ring-gold/30" animate={{
          y: [0, -14, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} width={1024} height={1024} data-id="element-21" data-mp="3jhocwrrc5xw0" />
        </motion.div>
      </div>
    </section>;
}